import React from "react";

import "./BreadcrumbBar.css";

/*
	TODO:
		- Ensure steps get even width allocation.
			- Can probably set `flex-basis = totalWidth / numSteps` or something.
*/

function TransitionSVG({ index, currentStep, numSteps }){
	if(index === numSteps - 1){
		return null;
	}

	let isLeftActive = (index === currentStep);
	let isRightActive = (index === currentStep - 1);

	return (
		<svg
			viewBox = "0 0 18 45"
		>
			<path
				className = {`transition ${isLeftActive ? "active" : ""}`}
				d = "
					M 0 0
					L 0 45
					L 16 22.5
				"
			/>
			<path
				className = {`transition ${isRightActive ? "active" : ""}`}
				d = "
					M 2 0
					L 18 22.5
					L 2 45
					L 18 45
					L 18 0
				"
			/>
			<path
				className = "transition-chevron"
				d = "
					M 0 -2
					L 16 22.5
					L 0 47
				"
			/>

		</svg>
	);
}

export default function BreadcrumbBar({ stepNames = ["..."], currentStep = 0 }){
	let numSteps = stepNames.length;
	let segments = stepNames.map((name, index) => {
		let isDone = (index < currentStep);

		let active = (index === currentStep) ? "active" : "";
		let done = isDone ? "done" : "";

		let displayNumber = isDone ? (<i className="fas fa-check" />) : index + 1;

		return (
			<React.Fragment key={name}>
				<div className={`step ${active} ${done}`}>
					<span className="step-number">{displayNumber}</span>{name}
				</div>
				<TransitionSVG
					index = {index}
					currentStep = {currentStep}
					numSteps = {numSteps}
				/>
			</React.Fragment>
		);
	});
	return (
		<div className="breadcrumb-bar">
			{segments}

		</div>
	);
}
